// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1Ld3P","range":"MonthRangeSwitch_range__2oQvo","disabled":"MonthRangeSwitch_disabled__2CuXI"};